'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var reactFinalForm = require('react-final-form');
var cn = require('classnames');
var ScriptTag = require('react-script-tag');
var WizardSlider = require('@piconetworks/wizard-slider');
var LandingWizardArrow = require('@piconetworks/landing-wizard-arrow');
var functions = require('@piconetworks/functions');
var Button = require('@piconetworks/button');
var text = require('@piconetworks/text');
var Form = require('@piconetworks/form');
var ContentFooter = require('@piconetworks/content-footer');
var layouts = require('@piconetworks/layouts');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var cn__default = /*#__PURE__*/_interopDefaultLegacy(cn);
var ScriptTag__default = /*#__PURE__*/_interopDefaultLegacy(ScriptTag);
var WizardSlider__default = /*#__PURE__*/_interopDefaultLegacy(WizardSlider);
var LandingWizardArrow__default = /*#__PURE__*/_interopDefaultLegacy(LandingWizardArrow);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var Form__default = /*#__PURE__*/_interopDefaultLegacy(Form);
var ContentFooter__default = /*#__PURE__*/_interopDefaultLegacy(ContentFooter);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var style = {"formArea":"Account-module_formArea__QTR4a","buttonContainer":"Account-module_buttonContainer__1jIyN","error":"Account-module_error__yLAqj","accountContainer":"Account-module_accountContainer__Pjtal","secureText":"Account-module_secureText__1NtCY","buttonGroup":"Account-module_buttonGroup__2JxOm","resetForm":"Account-module_resetForm__sM64T","approveButtonGroup":"Account-module_approveButtonGroup__l-La0","cancel":"Account-module_cancel__2Zh36","button":"Account-module_button__lWAc-","passwordStrength":"Account-module_passwordStrength__2fLD5","PasswordStrengthColor":"Account-module_PasswordStrengthColor__2Q5FJ","color_0":"Account-module_color_0__3bHl2","color_1":"Account-module_color_1__Yep_G","color_2":"Account-module_color_2__10X_t","color_3":"Account-module_color_3__3vnFH","color_4":"Account-module_color_4__1ky-w","backerBar":"Account-module_backerBar__19IMe","innerBar":"Account-module_innerBar__3GwK2","passwordWarning":"Account-module_passwordWarning__37YF0","passwordContainer":"Account-module_passwordContainer__rkYAU","showPassword":"Account-module_showPassword__15xny","wizardHeaderClass":"Account-module_wizardHeaderClass__2Xb-H","iconContainer":"Account-module_iconContainer__3KUFI","color":"Account-module_color__3zZde","left":"Account-module_left__3hG80","right":"Account-module_right__pyf0e","passwordInfo":"Account-module_passwordInfo__ZybhX","passwordInput":"Account-module_passwordInput__2KMII"};

var ShowPassword = function ShowPassword(_ref) {
  var _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$linkColor = _ref.linkColor,
      linkColor = _ref$linkColor === void 0 ? '#333' : _ref$linkColor,
      _ref$isShown = _ref.isShown,
      isShown = _ref$isShown === void 0 ? false : _ref$isShown;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      color: linkColor
    },
    className: cn__default['default'](style.showPassword),
    onClick: onClick
  }, functions.getSvgImage(linkColor, isShown ? 'eye-icon-crossed' : 'eye-icon'), /*#__PURE__*/React__default['default'].createElement("span", null, "".concat(isShown ? 'Hide' : 'Show', " Password")));
};

var PasswordMeter = function PasswordMeter(_ref) {
  var score = _ref.score;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.backerBar
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: cn__default['default'](style.innerBar, style["color_".concat(score)])
  }));
};

var PasswordStrength = function PasswordStrength(_ref) {
  var strength = _ref.strength,
      score = _ref.score;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: cn__default['default'](style.passwordStrength, style.PasswordStrengthColor, style["color_".concat(score)])
  }, strength || 'Password Strength');
};

var PasswordWarning = function PasswordWarning(_ref) {
  var warning = _ref.warning;

  if (!warning) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: cn__default['default'](style.passwordWarning)
  }, warning);
};

var EditPassword = function EditPassword(_ref) {
  var publisherId = _ref.publisherId,
      userLoader = _ref.userLoader,
      _ref$onUpdateSuccess = _ref.onUpdateSuccess,
      onUpdateSuccess = _ref$onUpdateSuccess === void 0 ? function () {} : _ref$onUpdateSuccess,
      account = _ref.account,
      router = _ref.router,
      WizardRedux = _ref.WizardRedux;
  return /*#__PURE__*/React__default['default'].createElement(AccountContainer, {
    publisherId: publisherId,
    userLoader: userLoader,
    skipWizardSubmit: true,
    type: "password",
    hideDefaultSubmitButtons: true,
    onUpdateSuccess: onUpdateSuccess,
    account: account,
    router: router,
    WizardRedux: WizardRedux
  });
};

EditPassword.defaultProps = {
  publisherId: null
};
EditPassword.propTypes = {
  publisherId: PropTypes__default['default'].string,
  account: PropTypes__default['default'].any.isRequired,
  userLoader: PropTypes__default['default'].any.isRequired,
  onUpdateSuccess: PropTypes__default['default'].func,
  router: PropTypes__default['default'].any.isRequired,
  WizardRedux: PropTypes__default['default'].any.isRequired
};

var getContrastColor = functions.colors.getContrastColor;

var AccountContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(AccountContainer, _React$Component);

  var _super = _createSuper(AccountContainer);

  function AccountContainer() {
    var _this;

    _classCallCheck(this, AccountContainer);

    _this = _super.call(this);
    _this.state = {
      doingSubmit: false,
      errorMessage: {},
      zxcvbn: null,
      password: {
        score: null,
        strength: null,
        warning: null
      },
      showPassword: false
    };
    _this.onLoadZxcvbn = _this.onLoadZxcvbn.bind(_assertThisInitialized(_this));
    _this.onPasswordChange = _this.onPasswordChange.bind(_assertThisInitialized(_this));
    _this.strengthConverter = _this.strengthConverter.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AccountContainer, [{
    key: "onLoadZxcvbn",
    value: function onLoadZxcvbn() {
      this.setState({
        zxcvbn: window.zxcvbn
      });
    }
  }, {
    key: "strengthConverter",
    value: function strengthConverter(score) {
      switch (score) {
        case 0:
          return 'Very Weak';

        case 1:
          return 'Weak';

        case 2:
          return 'Average';

        case 3:
          return 'Strong';

        case 4:
          return 'Very Strong';

        default:
          return '';
      }
    }
  }, {
    key: "onPasswordChange",
    value: function onPasswordChange(_ref) {
      var target = _ref.target;
      var zxcvbn = this.state.zxcvbn;

      if (zxcvbn) {
        var _ref2 = zxcvbn(target.value) || {},
            score = _ref2.score,
            _ref2$feedback = _ref2.feedback,
            feedback = _ref2$feedback === void 0 ? {} : _ref2$feedback;

        var warning = feedback.warning;
        this.setState({
          password: {
            score: score,
            strength: this.strengthConverter(score),
            warning: warning
          }
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var errorMessage = this.state.errorMessage;
      var _this$props = this.props,
          account = _this$props.account,
          type = _this$props.type,
          onUpdateSuccess = _this$props.onUpdateSuccess,
          initialize = _this$props.initialize,
          onEmailChange = _this$props.onEmailChange;
      var _account$updateAccoun = account.updateAccount,
          userDataUpdated = _account$updateAccoun.userDataUpdated,
          emailDataUpdated = _account$updateAccoun.emailDataUpdated,
          error = _account$updateAccoun.error;

      if (userDataUpdated === false && prevProps.account.updateAccount.userDataUpdated !== false || emailDataUpdated === false && prevProps.account.updateAccount.emailDataUpdated !== false) {
        this.setState({
          doingSubmit: false,
          errorMessage: Object.assign({}, errorMessage, !userDataUpdated && {
            user: error
          }, !emailDataUpdated && {
            email: error
          })
        }, function () {
          initialize();
        });
      }

      if (userDataUpdated === true && prevProps.account.updateAccount.userDataUpdated !== true || emailDataUpdated === true && prevProps.account.updateAccount.emailDataUpdated !== true) {
        this.setState(Object.assign({
          doingSubmit: false
        }, userDataUpdated === true && {
          user: null
        }, emailDataUpdated === true && {
          email: null
        }), function () {
          if (type === 'email') {
            onEmailChange({
              text: 'Please check your inbox to verify your new email address.'
            });
          }

          initialize();
          onUpdateSuccess();
        });
      }
    }
  }, {
    key: "renderWithWizard",
    value: function renderWithWizard(_ref3, children) {
      var type = _ref3.type;
          _ref3.linkColor;

      if (type === 'password') {
        return /*#__PURE__*/React__default['default'].createElement(WizardSlider__default['default'], {
          title: "Create a new password.",
          backButton: false,
          wizardHeaderClass: style.wizardHeaderClass
        }, children);
      }

      return children;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          doingSubmit = _this$state.doingSubmit,
          errorMessage = _this$state.errorMessage,
          showPassword = _this$state.showPassword,
          _this$state$password = _this$state.password,
          password = _this$state$password === void 0 ? {} : _this$state$password;
      var _this$props2 = this.props,
          account = _this$props2.account,
          publisherId = _this$props2.publisherId,
          userLoader = _this$props2.userLoader,
          update = _this$props2.update,
          _this$props2$skipWiza = _this$props2.skipWizardSubmit,
          skipWizardSubmit = _this$props2$skipWiza === void 0 ? false : _this$props2$skipWiza,
          type = _this$props2.type,
          router = _this$props2.router,
          _this$props2$hideDefa = _this$props2.hideDefaultSubmitButtons,
          hideDefaultSubmitButtons = _this$props2$hideDefa === void 0 ? false : _this$props2$hideDefa,
          updateLoaderUser = _this$props2.updateLoaderUser,
          WizardRedux = _this$props2.WizardRedux,
          utmRootUrl = _this$props2.utmRootUrl,
          queryOverride = _this$props2.queryOverride,
          changeMenuRoute = _this$props2.changeMenuRoute;

      if (!userLoader) {
        return null;
      }

      var _account$updateAccoun2 = account.updateAccount,
          emailDataUpdated = _account$updateAccoun2.emailDataUpdated,
          error = _account$updateAccoun2.error;
      var hasPasswordResetAuth = account.hasPasswordResetAuth;
      var linkColor = userLoader.publisher.styling.linkColor,
          has_password = userLoader.user.has_password;
      var contrastColor = getContrastColor(linkColor);
      var query = router.query;

      var _utmLink = functions.utmLink(Object.assign({}, queryOverride || query, {
        utmRootUrl: utmRootUrl
      })),
          trypico_link = _utmLink.trypico_link;

      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: style.accountContainer
      }, doingSubmit === true && /*#__PURE__*/React__default['default'].createElement(layouts.Loading, null), /*#__PURE__*/React__default['default'].createElement(WizardRedux.Step, {
        initialValues: {
          first_name: userLoader.user.first_name,
          last_name: userLoader.user.last_name,
          email: userLoader.user.email
        },
        validate: function validate() {
          var errors = {};
          return errors;
        },
        onSubmit: function onSubmit(_ref4) {
          var values = _ref4.values;

          if (!doingSubmit) {
            _this2.setState({
              doingSubmit: true
            });
          }

          var first_name = values.first_name,
              last_name = values.last_name,
              email = values.email,
              password = values.password,
              oldPassword = values.oldPassword;
          update(Object.assign({
            updateLoaderUser: updateLoaderUser,
            publisherId: publisherId
          }, first_name && first_name !== userLoader.user.first_name && {
            first_name: first_name
          }, last_name && last_name !== userLoader.user.last_name && {
            last_name: last_name
          }, email && email !== userLoader.user.email && {
            email: email
          }, oldPassword && {
            oldPassword: oldPassword
          }, password && {
            password: password
          }, hasPasswordResetAuth && {
            hasPasswordResetAuth: hasPasswordResetAuth
          }));

          if (skipWizardSubmit && !error) {
            throw {
              message: 'success'
            };
          }

          return {};
        },
        render: function render(_ref5) {
          var handleSubmit = _ref5.handleSubmit,
              submitError = _ref5.submitError,
              pristine = _ref5.pristine,
              values = _ref5.values;
          var buttonText = 'Profile';

          switch (type) {
            case 'name':
              buttonText = 'Name';
              break;

            case 'email':
              buttonText = 'Email';
              break;

            case 'password':
              buttonText = 'Password';
              break;
          }

          return _this2.renderWithWizard({
            type: type,
            linkColor: linkColor
          }, /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
            className: style.formArea
          }, type !== 'name' && type !== 'email' && type !== 'password' && /*#__PURE__*/React__default['default'].createElement("p", {
            className: style.secureText
          }, /*#__PURE__*/React__default['default'].createElement("span", {
            className: "icon-landing-page-case"
          }), "Your data is managed and secured by", /*#__PURE__*/React__default['default'].createElement("strong", null, /*#__PURE__*/React__default['default'].createElement("a", {
            href: trypico_link,
            target: "_blank",
            rel: "noopener noreferrer"
          }, "Pico."))), /*#__PURE__*/React__default['default'].createElement("form", {
            onSubmit: handleSubmit
          }, (type === 'name' || !type) && /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, {
            className: style.formInput,
            label: "First Name",
            name: "first_name",
            component: Form__default['default'].Input,
            type: "text"
          }), /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, {
            className: style.formInput,
            label: "Last Name",
            name: "last_name",
            component: Form__default['default'].Input,
            type: "text"
          })), (type === 'email' || !type) && /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, {
            className: style.formInput,
            label: "Email",
            name: "email",
            component: Form__default['default'].Input,
            type: "text"
          }), errorMessage.email && /*#__PURE__*/React__default['default'].createElement("div", {
            className: style.error
          }, errorMessage.email)), (type === 'password' || !type) && /*#__PURE__*/React__default['default'].createElement("div", {
            className: style.passwordContainer
          }, /*#__PURE__*/React__default['default'].createElement(text.P, {
            className: style.passwordInfo
          }, "Create a new password for the account", /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("strong", null, userLoader.user.email), "."), /*#__PURE__*/React__default['default'].createElement(ShowPassword, {
            linkColor: linkColor,
            isShown: showPassword,
            onClick: function onClick() {
              _this2.setState({
                showPassword: !showPassword
              });
            }
          }), /*#__PURE__*/React__default['default'].createElement(ScriptTag__default['default'], {
            type: "text/javascript",
            src: "https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/4.4.2/zxcvbn.js",
            onLoad: _this2.onLoadZxcvbn,
            async: true
          }), has_password && !hasPasswordResetAuth && /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, {
            className: style.formInput,
            label: "Old Password",
            name: "oldPassword",
            component: Form__default['default'].Input,
            type: showPassword ? 'text' : 'password',
            placeholder: has_password && '*******'
          }), /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, {
            name: "password"
          }, function (_ref6) {
            var input = _ref6.input,
                meta = _ref6.meta;
            return /*#__PURE__*/React__default['default'].createElement("div", {
              className: style.passwordInput
            }, /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Input, {
              meta: meta,
              label: has_password ? 'New Password' : 'Password',
              className: style.formInput,
              type: showPassword ? 'text' : 'password',
              placeholder: has_password && '*******',
              themeColor: linkColor,
              input: {
                type: showPassword ? 'text' : 'password',
                onChange: function onChange(e) {
                  _this2.onPasswordChange(e);

                  input.onChange(e);
                }
              }
            }), type === 'password' && /*#__PURE__*/React__default['default'].createElement(LandingWizardArrow__default['default'], {
              buttonType: "submit",
              className: cn__default['default'](style.iconContainer, style.right, style.color),
              style: {
                backgroundColor: linkColor,
                color: contrastColor
              },
              disabled: pristine || password.score < 2
            }));
          }), /*#__PURE__*/React__default['default'].createElement(PasswordMeter, {
            score: values.password && password.score,
            minScore: 0,
            maxScore: 4
          }), /*#__PURE__*/React__default['default'].createElement(PasswordStrength, {
            strength: password.strength,
            score: values.password && password.score
          }), /*#__PURE__*/React__default['default'].createElement(PasswordWarning, {
            warning: password.warning
          }), errorMessage.user && /*#__PURE__*/React__default['default'].createElement("div", {
            className: style.error
          }, errorMessage.user)), !hideDefaultSubmitButtons && /*#__PURE__*/React__default['default'].createElement("div", {
            className: style.approveButtonGroup
          }, /*#__PURE__*/React__default['default'].createElement("span", {
            onClick: function onClick() {
              return changeMenuRoute('/editProfile');
            },
            style: {
              color: linkColor
            },
            className: style.cancel
          }, "Cancel"), /*#__PURE__*/React__default['default'].createElement(Button__default['default'], {
            className: style.button,
            buttonType: "icon",
            type: "submit",
            disabled: pristine,
            style: {
              backgroundColor: linkColor,
              color: contrastColor
            }
          }, "Update", ' ', buttonText)), emailDataUpdated && /*#__PURE__*/React__default['default'].createElement("div", null, "check your email for more instructions on updating email address"), submitError && submitError !== 'success' && /*#__PURE__*/React__default['default'].createElement("div", {
            className: style.error
          }, submitError)))));
        }
      }), (type === 'password' || !type) && /*#__PURE__*/React__default['default'].createElement(ContentFooter__default['default'], {
        trypicoLink: trypico_link
      }));
    }
  }]);

  return AccountContainer;
}(React__default['default'].Component);

AccountContainer.defaultProps = {
  publisherId: null,
  onUpdateSuccess: function onUpdateSuccess() {},
  onEmailChange: function onEmailChange() {},
  utmRootUrl: null,
  queryOverride: null
};
AccountContainer.propTypes = {
  onUpdateSuccess: PropTypes__default['default'].func,
  onEmailChange: PropTypes__default['default'].func,
  publisherId: PropTypes__default['default'].string,
  router: PropTypes__default['default'].shape({
    pathname: PropTypes__default['default'].string,
    query: PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string,
      short_code: PropTypes__default['default'].string
    })
  }).isRequired,
  utmRootUrl: PropTypes__default['default'].string,
  queryOverride: PropTypes__default['default'].object,
  changeMenuRoute: PropTypes__default['default'].func
};

exports.EditPassword = EditPassword;
exports.PasswordMeter = PasswordMeter;
exports.PasswordStrength = PasswordStrength;
exports.PasswordWarning = PasswordWarning;
exports.ShowPassword = ShowPassword;
exports.default = AccountContainer;
